import request from "@/CommonDP/utils/request";

export default {
  queryPlatformApps(enterpriseId) {
    return request.get(`/platformApp/list?enterpriseId=${enterpriseId}`);
  },
  // 应用点击完保存
  savePubUserVisit(params) {
    return request.post("/pubUserVisitHistory/savePubUserVisit", params);
  },
  // 应用点击历史
  getAppHistoryList(businessType, clientType, enterpriseId) {
    return request.get(
      `/pubUserVisitHistory/app/list?businessType=${businessType}&clientType=${clientType}&enterpriseId=${enterpriseId}`
    );
  }
};
